import { ArrowLeft } from 'lucide-react';
import { TextButton } from '../ui';
import { useTranslation } from '../../../lib/i18n';
import { ContactsBody } from './ContactsBody';
import { ContactDetailBody } from './ContactDetailBody';

/**
 * The Outreach section under the map home: the SAME contacts list (every line a person, the last
 * communication the order, search, the New / Action required chips, mark-all-read) and, once a person is
 * picked, the SAME correspondence view the /contacts pages render — inline, with a way back to the list.
 * The picked person rides the URL (`?tab=messages&person=<id>`) so a refresh keeps the place.
 */
export function OutreachTabBody({ personId, onOpen, onBack }: { personId: string | null; onOpen: (personId: string) => void; onBack: () => void }) {
  const { t } = useTranslation();
  if (personId) {
    return (
      <>
        <TextButton size="small" startIcon={<ArrowLeft size={16} aria-hidden className="dir-flip" />} onClick={onBack}>
          {t('contacts.title')}
        </TextButton>
        <ContactDetailBody personId={personId} />
      </>
    );
  }
  return <ContactsBody onOpen={onOpen} />;
}
